import { FeatureEvent } from '@/interface/enum';
import type { FeatureEventStateResponse } from '@/interface/pollux';

export function formatFeatureEvents(response: FeatureEventStateResponse): FeatureEvent[] {
    return (response.completedEvents ?? []).map(FeatureEvent.fromPollux);
}
